import React from "react";
import YetkisizErisim from "../pages/kuyumcu/components/YetkisizErisim";

export default function SuperUserRoute({ children }) {
  const uyelikTip = localStorage.getItem("uyelikTip") || sessionStorage.getItem("uyelikTip");

  if (uyelikTip !== "SUPER_USER") {
    return <YetkisizErisim />;
  }

  return children;
}
